/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * InstructionLink component
 *
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.38.0
 */

import React from 'react';

import { Typography } from '@nexign/scc-ui-kit';

import { icons } from '@/main/assets';
import { LinkBlock } from '@components/common';
import { ImgStyled } from '@components/common/Block/Img';
import ArrowTooltip from '@components/common/Tooltip/Tooltip';

import { ELinkType, IInstructionLinkProps } from './types';

export const InstructionLink = (props: IInstructionLinkProps) => {
    const { tooltipText, instructionLink, linkText, linkType, linkRef } = props;

    switch (true) {
        case linkType === ELinkType.TEXT && !!instructionLink:
            return (
                <ArrowTooltip
                    message={tooltipText}
                    placement={'top'}
                >
                    <span>
                        <LinkBlock
                            isExternalUrl
                            data-testid='instruction-link'
                            linkRef={linkRef}
                            target={'_blank'}
                            url={instructionLink}
                        >
                            {linkText}
                        </LinkBlock>
                    </span>
                </ArrowTooltip>
            );
        case linkType === ELinkType.INFO_ICON && !!instructionLink:
            return (
                <ArrowTooltip
                    message={
                        <span>
                            <Typography>
                                {tooltipText}
                            </Typography>
                            <LinkBlock
                                isExternalUrl
                                data-testid='instruction-link'
                                linkRef={linkRef}
                                target={'_blank'}
                                url={instructionLink}
                            >
                                {linkText}
                            </LinkBlock>
                        </span>
                    }
                    placement={'top'}
                >
                    <ImgStyled height={'16px'} src={icons.infoBlueIcon} width={'16px'} />
                </ArrowTooltip>
            )
        default:
            return <></>;
    }
};
